import script from "./config-quality.vue?vue&type=script&setup=true&lang=js"
export * from "./config-quality.vue?vue&type=script&setup=true&lang=js"

import "./config-quality.vue?vue&type=style&index=0&id=5c572664&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c572664"]])

export default __exports__